import styles from "./StudyFiltersDesktop.module.scss";
import T from "../../../../shared/component/t/T";
import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import snippets from "../../../../helpers/snippets";
import { default as _ } from '../../../../helpers/Translate';
import Button from "../../../../shared/component/button/Button";


function StudyFiltersDesktop(props) {
    const [ device ] = useState(props.device)
    const [ show, setShow ] = useState();

    const divRef = useRef()
    const [filters, setFilters] = useState ([])
    const [selected, setSelected] = useState(undefined);
    const [defaultFilterID, setDefaultFilterID] = useState(undefined);

    useEffect(() => {
        if (show){
            document.addEventListener("click", handleClickOutside);
            document.addEventListener("keydown", keyPressESC)
        } else if (show === false){
            document.removeEventListener("keydown", keyPressESC);
            document.removeEventListener("click", handleClickOutside)
        }
        return ()=> {
            document.removeEventListener("keydown", keyPressESC);
            document.removeEventListener("click", handleClickOutside)
        }
    }, [show]);

    useEffect(() => {
        setShow(props.show)
        setFilters(props.data?.filters)
        setSelected(props.data?.selected)
        setDefaultFilterID(props.data?.defaultID)
    }, [props.show, props.data]);

    useEffect(() => {
        //make div smaller if there isn't any filter
        if (show){
            let main = document.getElementById("main_study_filter")
            if (main && snippets.isObjectEmpty(filters)){
                main.style.height = "200px"
            }
        }
    }, [show]);


    const closeModal = () => {
        props.onClose()
    }

    const handleWindows = () => {
        return props.otherWindows()
    }

    const handleClickOutside = (event) => {
        let otherWindowsOpen = handleWindows()
        if (divRef?.current && !otherWindowsOpen && !divRef.current?.contains(event.target)) {
            closeModal()
        }
    }

    const keyPressESC = (event) => {
        if (event.key === "Escape" && !handleWindows()) {
            closeModal()
        }
    }
    const add = () => {
        props.functions?.add()
        closeModal()
    }

    const apply = (item) => {
        props.functions?.apply(item.id)
        closeModal()
    }

    const details = (item) => {
        props.functions?.details(item)
    }

    const del = (item) => {
        props.functions?.delete(item)
    }

    const makeItDefault = (id) => {
        props.functions?.changeDefault(id).then(()=>{
            setDefaultFilterID(id)
        })
    }

    const addNewStudyFilterBtn = () => {
        return <Button className={`create_new_studyFilter`}
                      size="small"
                      customClasses="margin-2px"
                      buttonText={"study_filter_new"}
                      mode="warning-new"
                      key={0}
                      onClick={add}
        />
    }

    const ItemShowing = (item, index) => {
        let isSelected = +item.id === +selected
        let isDefault = +item.id === +defaultFilterID

        return <tr className={styles.list_body_item} key={item.id}>
            <td>{_.init3(index+1)}</td>
            <td>{item.text}</td>
            <td>
                <Button className={`create_new_studyFilter`}
                        size="small"
                        customClasses="margin-2px"
                        buttonText={"details"}
                        mode="primary-transparent"
                        onClick={()=>details(item)}
                />
                <Button className={`create_new_studyFilter`}
                        size="small"
                        customClasses="margin-2px"
                        buttonText={"delete"}
                        mode="primary-transparent"
                        onClick={()=>del(item)}
                />
                {!isSelected &&
                    <Button className={`create_new_studyFilter`}
                            size="small"
                            customClasses="margin-2px"
                            buttonText={"apply_filter"}
                            mode="primary-transparent"
                            onClick={()=>apply(item)}
                    />
                }
            </td>
            <td className={styles.list_body_item_heart}
                onClick={()=>makeItDefault(item.id)}>
                <i className={`${isDefault ? "fa" : "fal"} fa-heart`}/>
            </td>
        </tr>
    }

    const studyFilterList = () => {

        return(<div className={styles.list}>
            <div className={styles.list_title}>
                <T token={"quick_filters_list"} />
                {addNewStudyFilterBtn()}
            </div>

            <table className={styles.list_body}>
                <thead className={styles.list_body_header}>
                    <tr>
                        <th> <T token={"rows"} /></th>
                        <th> <T token={"study_filter_title"} /> </th>
                        <th> <T token={"operations"} /> </th>
                        <th> <T token={"default"} /> </th>
                    </tr>
                </thead>
                <tbody className={styles.list_body_items}>
                    {filters.map((item, index) => ItemShowing(item, index))}
                </tbody>
            </table>
        </div>)
    }

    const noStudyFilter = () => {
        return (<div className={styles.noFilter}>
            <div className={styles.noFilter_header}>
                <div><T token={"no_pattern"} /></div>
                <div><T token={"add_pattern_msg"} /></div>
            </div>
            <div className={styles.noFilter_button}>
                {addNewStudyFilterBtn()}
            </div>
        </div>)
    }

    const desktopMode = () => {
        return(<>
            {show && <div className={styles.main}
                                  id={"main_study_filter"}
                                  ref={divRef}>
                <div className={styles.main_header} >
                    <div className={styles.main_triangle} > &#9650; </div>
                    <div className={styles.main_header_close}
                         onClick={closeModal}
                    >
                        <i className={"fal fa-times-circle fa-xl"} />
                    </div>
                </div>
                {filters.length > 0 ? studyFilterList() : noStudyFilter()}
            </div>}
        </>)
    }

    const mainHandler = () => {
        switch (device) {
            case "desktop":
                return desktopMode()
            default:
                return console.error("this menu is not compatible with non-desktop mode")
        }
    }

    return(
        <> {mainHandler()} </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const device = state.DeviceModeReducer.mode;
    return {language, device};
};

export default connect(mapStateToProps)(StudyFiltersDesktop);